import React, { SyntheticEvent, useRef, useState } from 'react'
import { ReactComponent as IcoDM } from 'assets/icons/Logo.svg'
import style from './Auth.module.css'
import { useNavigate, useParams } from 'react-router-dom'
import axiosClient from 'axios-client'

const ChangePW: React.FC = () => {
  const { token } = useParams()
  const [message, setMessage] = useState('')
  const navigate = useNavigate()

  const emailRef = useRef<HTMLInputElement>(null)
  const passwordRef = useRef<HTMLInputElement>(null)
  const confirmationRef = useRef<HTMLInputElement>(null)

  const [loading, setLoading] = useState(false)

  const onSubmit = (ev: SyntheticEvent) => {
    ev.preventDefault()

    const pass = passwordRef.current?.value
    const confirm = confirmationRef.current?.value

    if (pass === confirm) {
      setLoading(true)
      axiosClient
        .post('/resetpassword', {
          email: emailRef.current?.value,
          password: pass,
          password_confirmation: confirm,
          token: token,
        })
        .then(() => {
          setMessage('Password changed successfully. You can now log in.');
          //navigate('/login')
        }).finally(()=>setLoading(false))
    } else {
      setMessage('The fields does not match!')
    }
  }

  return (
    <form className={`${style.form}`}>
      <IcoDM className={`${style.logo}`} />
      <input
        type='email'
        placeholder='Email'
        className={`${style.input}`}
        ref={emailRef}
        required
      />
      <input
        type='password'
        placeholder='New password'
        className={`${style.input}`}
        ref={passwordRef}
        required
      />
      <input
        type='password'
        placeholder='Repeat password'
        className={`${style.input}`}
        ref={confirmationRef}
        required
      />
      <div
        className={`${style.row} ${style.message}`}
        style={{ display: message === '' ? 'none' : '' }}
      >
        {message}
      </div>
      <input
        type='submit'
        value={loading ? 'Sending request...' : 'Submit'}
        className={`${style.submit}`}
        onClick={onSubmit}
        disabled={loading}
      />
    </form>
  )
};

export default ChangePW;
